import React from "react";
import SingleQuoteContent from "../components/quotes/single-quote-content";

const SingleQuote = () => {
  return <SingleQuoteContent />;
};

export default SingleQuote;
